export default __webpack_public_path__ + "static/piskorska-0256d0d241eeae0328f994aeccc02df7.jpg";